import { canvasCreateCommand } from './canvas_create';

export const canvasCommands = [
  canvasCreateCommand
];

